import Vue from 'vue'
import Vuex from 'vuex'
import http from '../../httpuntil'
Vue.use(Vuex)
// initial state
const state = {
    videos: [],
}

const getters = {
    // products: state => {
    //     return state.products;
    // },
    // categories: state => {
    //     return state.categories;
    // }
}
// actions
const actions = {
  getVideos ({commit},filter) {
      console.log(filter)
      http.post("/api/VideoNews/list",filter,(data)=>{
        if (data.Success) {
          commit('setVideos',data.Data.Results);
        }
      },(e)=>{
        console.log(e);
      });
  },
}

// mutations
const mutations = {
  setVideos (state, videos) {
    //  state.videos=state.videos.concat(videos);
     state.videos=videos;
  },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
